import { clientFetchUrl, imageUrl } from "@/utils/constants";

import { UUID } from "crypto";
import ImageUploader from "@/app/components/ui/ImageUploader";
import { useEffect, useId, useState } from "react";
import VideoUploader from "@/app/components/ui/VideoUploader";
import ResponseInput from "../quiz/inputs/ResponseInput";

export type SlideProps = {
  slide_type: UUID;
  selectedSlide?: Slide;
  updateTitle?: Function;
  updateImage?: Function;
  updateVideo?: Function;
  updateText?: Function;
  updateVoice?: Function;

  session: Session;
  slideTypes: SelectItem[];
};
export default function SlidePage({
  slide_type,
  selectedSlide,
  updateImage,
  updateText,
  updateTitle,
  updateVideo,
  session,
  slideTypes,
  updateVoice,
}: SlideProps) {
  const [videoUrl, setVideoUrl] = useState<string>();
  const [thisImageUrl, setThisimageUrl] = useState<string>();
  const [voiceUrl, setVoiceUrl] = useState<string>();
  useEffect(() => {
    if (selectedSlide.image_url)
      setThisimageUrl(imageUrl + "/" + selectedSlide.image_url);
    else {
      setThisimageUrl(undefined);
    }
    if (selectedSlide.video_url)
      setVideoUrl(imageUrl + "/" + selectedSlide.video_url);
    else setVideoUrl(undefined);
    if (selectedSlide.voice_url) setVoiceUrl("/" + selectedSlide.voice_url);
    else {
      setVoiceUrl(undefined);
    }
  }, [selectedSlide.image_url, selectedSlide.video_url]);
  const handleTitleChange = (value: string, i: number) => {
    const updatedSelectedSlide: Slide = { ...selectedSlide, title: value };
    if (updateTitle) updateTitle(updatedSelectedSlide);
  };

  const handleTextChange = (value: string) => {
    const updatedSelectedSlide: Slide = { ...selectedSlide, text: value };
    if (updateText) updateText(updatedSelectedSlide);
  };

  const handleVideoChange = (video: any) => {
    if (video) {
      var formData = new FormData();
      formData.append("content", video);

      const modalSetting: UpdateActivity = {
        url: "/api/content/v1/UploadImage/",
        formdata: formData,
      };

      fetch(clientFetchUrl + modalSetting.url, {
        method: "POST",
        body: modalSetting.formdata,
        headers: {
          Authorization: `Bearer ${session?.accessToken}`,
        },
      })
        .then((res) => res.json())
        .then((result: UploadImageReturn) => {
          setVideoUrl(imageUrl + "/" + result.content_name);
          if (updateVideo) updateVideo(result.id, result.content_name);
        })
        .catch((error) => {
          console.error("Error saving activity:", error);
        });
    } else {
      setVideoUrl(undefined);
      updateVideo(undefined, undefined);
    }
  };
  const handleImageChange = (image: any) => {
    if (image) {
      var formData = new FormData();
      formData.append("content", image);

      const modalSetting: UpdateActivity = {
        url: "/api/content/v1/UploadImage/",
        formdata: formData,
      };

      fetch(clientFetchUrl + modalSetting.url, {
        method: "POST",
        body: modalSetting.formdata,
        headers: {
          Authorization: `Bearer ${session?.accessToken}`,
        },
      })
        .then((res) => res.json())
        .then((result: UploadImageReturn) => {
          if (updateImage)
            setThisimageUrl(imageUrl + "/" + result.content_name);
          updateImage(result.id, result.content_name);
        })
        .catch((error) => {
          console.error("Error saving activity:", error);
        });
    } else {
      setThisimageUrl(undefined);
      updateImage(undefined);
    }
  };
  const handleVoiceChange = (video: any) => {
    if (video) {
      var formData = new FormData();
      formData.append("content", video);

      const modalSetting: UpdateActivity = {
        url: "/api/content/v1/UploadImage/",
        formdata: formData,
      };

      fetch(clientFetchUrl + modalSetting.url, {
        method: "POST",
        body: modalSetting.formdata,
        headers: {
          Authorization: `Bearer ${session?.accessToken}`,
        },
      })
        .then((res) => res.json())
        .then((result: UploadImageReturn) => {
          setVoiceUrl("/" + result.content_name);
          if (updateVoice) updateVoice(result.id, result.content_name);
        })
        .catch((error) => {
          console.error("Error saving activity:", error);
        });
    } else {
      setVoiceUrl(undefined);
      updateVoice(undefined, undefined);
    }
  };
  const image_id = useId();

  return (
    <div className="flex flex-col gap-6   w-full h-full">
      <div className="flex md:flex-row flex-col items-start gap-2.5 rounded-xl bg-bg-cards h-full w-full">
        {(selectedSlide.slide_type ===
          slideTypes!.find((type) => type.code === "text_only")?.id ||
          selectedSlide.slide_type ===
            slideTypes!.find((type) => type.code === "text_slide")?.id) && (
          <div className="flex md:p-6 p-3 flex-col items-start gap-6 rounded-xl bg-bg-cards w-full h-full">
            <ResponseInput
              placeHolder={"عنوان"}
              styleClass="h-[52px]"
              inputValue={selectedSlide.title}
              valueUpdated={handleTitleChange}
              index={0}
              hasFile={false}
              id={`file-input-matching-choice-${image_id}`}
              tabIndex={1}
            />
            {/* <Input
              placeholder={"عنوان"}
              styleClass=" w-full"
              handleInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleTextChange(e.target.value);
              }}
            /> */}
            <ResponseInput
              placeHolder={"متن"}
              styleClass=" h-full w-full min-h-[200px]"
              inputValue={selectedSlide.text}
              valueUpdated={handleTextChange}
              index={0}
              hasFile={false}
              id={`slide-text-${image_id}`}
              tabIndex={2}
              hasAudio={true}
              handleVoiceChange={handleVoiceChange}
              inputVoice={voiceUrl}
            />
          </div>
        )}
        {selectedSlide.slide_type ===
          slideTypes!.find((type) => type.code === "video_only")?.id && (
          <div className="flex  md:p-6 p-3 flex-col items-start gap-6 rounded-xl bg-bg-cards w-full h-full">
            <VideoUploader
              editable={true}
              width={"w-full"}
              height={"h-full"}
              handler={handleVideoChange}
              videoUrl={videoUrl}
              uniqueId={`img-activity-setting-12313dfdf`}
              controls={true}
            />
          </div>
        )}

        {(selectedSlide.slide_type ===
          slideTypes.find((type) => type.code === "image_only")?.id ||
          selectedSlide.slide_type ===
            slideTypes.find((type) => type.code === "text_slide")?.id) && (
          <div className="flex  md:p-6 p-3 flex-col items-start gap-6 rounded-xl bg-bg-cards w-full h-full">
            <ImageUploader
              editable={true}
              width={"w-full"}
              height={"md:h-full h-[150px]"}
              imageUrl={thisImageUrl}
              handler={handleImageChange}
              uniqueId="slide-image-uploader"
            />
          </div>
        )}
      </div>
    </div>
  );
}
